<template>
	<div>
		<breadcrumbs />

		<loading :active.sync="isLoading"></loading>

		<div class="content-i">
			<div class="content-box">
				<div class="row pt-4">
					<div class="col-sm-12">

						<div class="element-wrapper">

							<h6 class="element-header" v-b-toggle.filter variant="primary">
								{{ t.navigation.bet_award_history }}
							</h6>
							<div class="element-box-tp">
									<table-component
											v-if="status == 200"
											table-class="table table-padded"
											filter-input-class="form-control col-4 float-right rounded bright"
											:data="data"
											sort-by="id"
											sort-order="desc"
									>

									<table-column cell-class="w250">
										<template slot-scope="row">
											<router-link :to="{name: 'userprofile', params: {id: row.id}}">{{ row.user.username }}</router-link>
										</template>
									</table-column>

									<table-column :label="t.betting.cancelled" cell-class="w150 text-right">
										<template slot-scope="row">
											{{ row.stats.cancelledTotal | toMoney(row.user.currency) }}
										</template>
									</table-column>

									<table-column :label="t.betting.win" cell-class="w150 text-right">
										<template slot-scope="row">
											{{ row.stats.winTotal | toMoney(row.user.currency) }}
										</template>
									</table-column>

									<table-column :label="t.betting.loss" cell-class="w150 text-right">
										<template slot-scope="row">
											{{ row.stats.lossTotal | toMoney(row.user.currency) }}
										</template>
									</table-column>

									<table-column :label="t.betting.waiting" cell-class="w150 text-right">
										<template slot-scope="row">
											{{ row.stats.waitingTotal | toMoney(row.user.currency) }}
										</template>
									</table-column>

									<table-column :label="t.total" cell-class="w150 text-right">
										<template slot-scope="row">
											{{ row.stats.Total | toMoney(row.user.currency) }}
										</template>
									</table-column>

									<table-column label="%" cell-class="w50 text-right">
										<template slot-scope="row">
											<router-link :to="{name: 'bet_trends', query: {user: row.id, period: selectedPeriod}}">{{ (row.stats.waiting + row.stats.loss + row.stats.win + row.stats.cancelled) | percentage(totalPlayed) }}%</router-link>
										</template>
									</table-column>

								</table-component>
							</div>
						</div>

					</div>
				</div>
			</div>

			<!--------------------
				START - Sidebar
				-------------------->
			<div class="content-panel compact">
				<div class="content-panel-close" v-on:click="controlPanel">
					<i class="ti-shift-right"></i>
				</div>
				<div class="element-wrapper">

					<h6 class="element-header" v-b-toggle.filter variant="primary">
						{{ t.filter.title }}
					</h6>
					<div class="element-box-tp">

						<form class="justify-content-sm-end">
							<select class="form-control form-control-sm form-control-faded" v-model="selectedPeriod">
								<option v-for="option in accountingPeriods" v-bind:value="option.value">
									{{ t.filter.accounting[option.value] }}
								</option>
							</select>
						</form>

					</div>
				</div>
			</div>
			<!--------------------
			END - Sidebar
			-------------------->
		</div>


	</div>
</template>

<script>
    import formatter from '@/mixins/formatter'
    import { TableComponent, TableColumn } from 'vue-table-component'

    export default {
        name: 'rewardTrends',
        components: { 'table-component': TableComponent, 'table-column': TableColumn},
        mixins: [formatter],
        data () {
            return {
                isLoading: false,
                t: this.$root.t,
                data: '',
                status: 0,
                w: window.innerWidth,
                totalPlayed: 0,
                selectedPeriod: 'today',
                accountingPeriods: [
                    { label: 'Today', value: 'today' },
                    { label: 'Yesterday', value: 'yesterday' },
                    { label: 'This Week', value: 'this_week' },
                    { label: 'This Month', value: 'this_month' },
                    { label: 'Q1', value: 'q1' },
                    { label: 'Q2', value: 'q2' },
                    { label: 'Q3', value: 'q3' },
                    { label: 'Q4', value: 'q4' },
                    { label: 'Financial First Half', value: 'first_financial_half' },
                    { label: 'Financial Second Half', value: 'second_financial_half' },
                ],
                sports: null,
                sport: 1
            }
        },
        watch: {
            '$route.query' (o,n) {
                this.fetchReport()
            },
            '$route.query.market' () {
                this.$refs.playedBets.open()
            },
            'selectedPeriod' (o, n) {
                this.fetchReport()
	            this.$route.query.period = n;
                this.$router.push({query: this.$route.query });
            },
            'sport' (v) {
                this.fetchReport()
	            this.$route.query.sport = v;
                this.$route.query.period = this.selectedPeriod;
                this.$router.push({query: this.$route.query });
            }
        },
        mounted () {

            this.$route.query.period = (this.$route.query.period) ? this.$route.query.period : this.selectedPeriod;
            this.$route.query.sport = (this.$route.query.sport) ? this.$route.query.sport : this.sport;

            this.fetchSports()
            this.fetchReport()
        },
        methods: {
            closeModal () {
                this.$router.push({ query: { market: 99999 } });
                setTimeout( () => {
                    window.document.body.style.overflow = 'auto';
            }, 500);
            },
            fetchReport () {
                this.isLoading = true;
                this.$http.get(api+'api/v1/analytics/bet/users', {params: this.$route.query}).then(response => {
                    // get body data
                    this.data = response.body.result;
                this.totalPlayed = response.body.totalPlayed;
                this.isLoading = false;
                this.status = response.status;

            }, response => {
                    this.isLoading = false;
                    this.status = response.status;
                })
            },
            fetchSports () {
                this.$http.get(api+'api/v1/fixture/sport?per_page=100').then(response => {
                    // get body data
                    this.sports = response.body.result.sport;

            }, response => {
                    this.isLoading = false;
                    this.status = response.status;
                })
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/reports/rewardTrends.vue